/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	const topLineupSwiper = () => {
		const splide = new Splide('.top-LineupSlide.splide', {
			type: 'loop',
			perPage: 2,
			autoplay: false,
			interval: 5000,
			speed: 500,
			arrows: true,
			pagination: true,
			paginationKeyboard: true,
			gap: 20,
			breakpoints: {
				1025: {
					perPage: 1,
					gap: 0,
				}
			},
		}).mount();
	};

	const topLineupList = () => {
		document.addEventListener("DOMContentLoaded", () => {
			const menuItems = document.querySelectorAll(".top-section02-column02-list a");
			const contentBox = document.querySelector(".top-section02-column02-box");
		
			// solutionデータ
			const contentData = [
				{
					title: "ロジスティクスソリューション",
					buttonUrl: "/solution/logistics/",
					buttonText: "ロジスティクス",
					description: "インフォセンスは、総合物流企業「山九」のグループ会社として、お客さまのロジスティクス最適化に向けたソリューションを提供します。",
					imgSrc: "/images/solution/top/img_02.webp",
					services: [
						{
							text: "ZIZAIA WMSがグレードアップして新登場！更なる効率化/品質向上を実現するパッケージへ。<br>ZIZAIAの機能はそのままに、構内物流へに標準対応、見える化機能の大幅拡充、在庫管理の柔軟性向上などにより、ロジスティクス全体の効率化をサポートします。",
							url: "/solution/zizaia/",
							imgSrc: "/images/solution/top/zizai.webp",
							labels: ["ロジスティクス", "倉庫管理システム"],
							heading: "ZIZAIA WMS 2.0"
						},
						{
							text: "お客さま（荷主企業、物流事業者）の経営課題に対して、経営/管理/現場層別の視座から、多面的・定量的に分析します。<br>作業改善/システム活用/設備改善を融合（コーディネート） して、経営課題解決による「お客さまの企業価値向上」に貢献 します。",
							url: "/solution/logistics-consulting/",
							imgSrc: "/images/solution/top/logo.webp",
							labels: ["ロジスティクス","コンサルティング"],
							heading: "ロジスティクスコンサルティング"
						},
						{
							text: "遠隔点呼やIT点呼に対応し、点呼・車両・運転手の情報を一元管理できるクラウドシステムです。",
							url: "/dtenko/dtm.html",
							imgSrc: "/images/solution/top/dtenko.webp",
							labels: ["ロジスティクス","アプリ構築","運行管理支援システム"],
							heading: "デジタル点呼マネージャー"
						}
					]
				},
				{
					title: "基幹業務",
					buttonUrl: "/solution/core/",
					buttonText: "基幹業務",
					description: "インフォセンスでは、企業を支える基幹業務システムについても、お客さまのビジネススタイルに合わせてあるべき姿を提案します。",
					imgSrc: "/images/solution/top/img_03.webp",
					services: [
						{
							text: "お客さまのデジタル・トランスフォーメーション（DX）の取組み状況に合わせたコンサルティング・　サービスを用意しています。",
							url: "",
							imgSrc: "/images/solution/top/logo.webp",
							labels: ["基幹業務","コンサルティング"],
							heading: "ITコンサルティング"
						},
						{
							text: "GRANDITは、お客さまの目的や課題解決に対応した拡張性の高い統合基幹システム（ERPパッケージ）です。",
							url: "/solution/grandit/",
							imgSrc: "/images/solution/top/grandit.webp",
							labels: ["基幹業務","ERP及び周辺ソリューション"],
							heading: "GRANDIT"
						},
						{
							text: "POSITIVEは、人事・給与・就業管理・ワークフローだけでなく、要員計画や人財育成に活用できるタレントマネジメント機能など、豊富な機能を兼ね備えたパッケージ製品です。",
							url: "/solution/positive/",
							imgSrc: "/images/solution/top/positive.webp",
							labels: ["基幹業務","ERP及び周辺ソリューション"],
							heading: "POSITIVE"
						}
					]
				},
				{
					title: "アプリ構築",
					buttonUrl: "/solution/application/",
					buttonText: "アプリ構築",
					description: "高品質・高安全性を担保しながら新技術を積極的に導入し、お客さまのビジネスに寄り添ったITサービスをオーダーメイドで提供します。",
					imgSrc: "/images/solution/top/img_04.webp",
					services: [
						{
							text: "IssTは業務システム向けのUI開発プラットフォーム(開発・実行環境)です。",
							url: "/solution/isst/",
							imgSrc: "/images/solution/top/isst.webp",
							labels: ["アプリ構築","ロジスティクス","デバイスソリューション"],
							heading: "IssT"
						},
						{
							text: "・プログラムの開発や、Webサーバーやデータベースの導入・構築・運用まで、システム全般をカバーします。<br>・ユーザー側の目に触れない部分も高い品質で構築します。",
							url: "",
							imgSrc: "/images/solution/top/logo.webp",
							labels: ["アプリ構築","Webアプリ構築"],
							heading: "バックエンド開発"
						},
						{
							text: "・Webサービスやアプリの操作画面などユーザの目に触れる部分の構築を実施します。<br>・ユーザが直接目にするため、操作性に配慮した開発を実施します。",
							url: "",
							imgSrc: "/images/solution/top/logo.webp",
							labels: ["アプリ構築","Webアプリ構築"],
							heading: "フロントエンド開発"
						}
					]
				},
				{
					title: "DX支援",
					buttonUrl: "/solution/dx/",
					buttonText: "DX支援",
					description: "DX（デジタルトランスフォーメーション）とは、企業がデジタル技術を活用して、ビジネスモデルや業務プロセス、組織文化、企業風土などを変革し、競争力を高める取り組みです。インフォセンスでは、お客さまに合わせたDXソリューションを取り揃えています。",
					imgSrc: "/images/solution/top/img_05.webp",
					services: [
						{
							text: "・企業の持つさまざまなデータから得られた情報をもとに、ビジネスにおける現状の問題点や解決策を洗い出し、企業活動へと反映させます。<br>・データ活用のスムーズな推進のために、課題の整理をサポートします。",
							url: "",
							imgSrc: "/images/solution/top/logo.webp",
							labels: ["DX支援","データ分析支援（BA/AI）"],
							heading: "データ活用課題整理"
						},
						{
							text: "QlikSenseはビジネスユーザーがセルフサービスでデータを探索できるBIプラットフォームです。<br>データ分析における全てのニーズに対応可能なエンタープライズ環境を提供。<br>2つのAIテクノロジーを必要なユーザーへ届けて、企業のデータ活用を強化します。",
							url: "/solution/qlik-sense/",
							imgSrc: "/images/solution/top/qlik-sense.webp",
							labels: ["ロジスティクス","DX支援","データ可視化支援（BI）"],
							heading: "QlikSense"
						},
						{
							text: "DataSpider Servistaは各種システム・データソースに対してデータをつなぐHUBとしての役割を担い、各種システム・データソースの開発においてもGUI開発により早期にシステム・データ連携基盤を構築できるデータ連携統合基盤です。",
							url: "/solution/dataspider/",
							imgSrc: "/images/solution/top/dataspider.webp",
							labels: ["DX支援","データ活用基盤構築（ETL/DWH）"],
							heading: "DataSpider"
						}
					]
				},
				{
					title: "インフラ",
					buttonUrl: "/solution/infrastructure/",
					buttonText: "インフラ",
					description: "仮想化や、セキュリティ性の向上、資産管理など、お客さまのニーズに合わせて最適なインフラソリューションを実現します。",
					imgSrc: "/images/solution/top/img_06.webp",
					services: [
						{
							text: "既存の「新型コロナウイルス対策ソリューション」を「テレワークソリューション」に変更して掲載",
							url: "/solution/telework/",
							imgSrc: "/images/solution/top/logo.webp",
							labels: ["インフラ","テレワークソリューション"],
							heading: "テレワークソリューション"
						},
						{
							text: "サーバ構成や実現したいサービスの内容についてヒアリングを行い、システムを導入した場合の最適な構成、当社作業範囲、費用感をご提案します。",
							url: "/solution/examination-support/",
							imgSrc: "/images/solution/top/logo.webp",
							labels: ["インフラ","インフラ導入検討支援サービス"],
							heading: "インフラ導入検討支援サービス"
						},
						{
							text: "オンプレミスやAWS構築・運用で培った豊富な経験を活かし、AWSソリューションアーキテクトの資格を持った技術者がAWS導入をご支援します。",
							url: "/solution/aws/",
							imgSrc: "/images/solution/top/aws.webp",
							labels: ["インフラ","クラウドソリューション"],
							heading: "AWS導入サービス"
						}
					]
				},
			];
		
			let splideInstance;

			const adjustHeights = () => {
				const $elements = document.querySelectorAll('[data-mh]');
				const groups = new Map();
	
				$elements.forEach(ele => { ele.style.height = 'auto'; }); // 初期化
	
				$elements.forEach(ele => {
					const attributeName = ele.getAttribute('data-mh');
					if (!groups.has(attributeName)) {
						groups.set(attributeName, []);
					}
					groups.get(attributeName).push(ele);
				});
	
				groups.forEach(group => {
					const attributeGroups = new Map();
					group.forEach(ele => {
						const attributeName = ele.getAttribute('data-mh');
						const topPosition = ele.getBoundingClientRect().top;
						const key = attributeName + '_' + topPosition;
						if (!attributeGroups.has(key)) {
							attributeGroups.set(key, []);
						}
						attributeGroups.get(key).push(ele);
					});
	
					attributeGroups.forEach(item => {
						const maxHeight = Math.max(...item.map(ele => ele.offsetHeight));
						item.forEach(ele2 => {
							ele2.style.height = `${maxHeight}px`;
						});
					});
				});
			};
		
			menuItems.forEach((item, index) => {
				item.addEventListener("click", () => {
					menuItems.forEach(menuItem => menuItem.classList.remove(a));
					item.classList.add(a);
					const data = contentData[index];
					contentBox.innerHTML = `
						<div class="top-section02-column02-box-column">
							<h3 class="">${data.title}</h3>
							<a data-view="pc" href="${data.buttonUrl}" class="mod-button02 _right">
								<span>${data.buttonText}</span>
								<svg class="_right _arrow" aria-hidden="true">
									<use xlink:href="/common/svg/sprite.svg#arrow_right02"></use>
								</svg>
							</a>
						</div>
						<p class="mod-spacer_32 sp_ml40 sp_mr40">${data.description}</p>
						<figure class="mod-spacer_32"><img src="${data.imgSrc}" class="mod-imgRadius" alt=""></figure>
						<h4 class="mod-spacer_32 mod-head07">サービスラインナップ</h4>
						<div class="top-LineupSlide splide mod-spacer_16">
							<div class="splide__track">
								<ul class="splide__list">
									${data.services
										.map(service => `
										<a 
											${service.url ? `href="${service.url}"` : ""} 
											class="__item splide__slide ${service.url ? "" : "disabled"}"
										>
											<div class="__itemList">
												<picture>
													<source srcset="${service.imgSrc}" media="(max-width:767px)">
													<img src="${service.imgSrc}" alt="" class="width-u-100" width="240" height="120">
												</picture>
												<div>
													<div class="mod-labelWrap">
														${service.labels
															.map((label, index) => `
																<span class="mod-label ${index === 0 ? '_pink' : 'mr5'}">${label}</span>
															`).join("")}
													</div>
													<h4 data-mh="_ttl" class="fs_20 fw_bold mod-spacer_8">${service.heading}</h4>
													<p data-mh="_txt" class="mod-spacer_8">${service.text}</p>
												</div>
											</div>
										</a>
									`)
										.join("")}
								</ul>
							</div>
						</div>
						<a data-view="tablet sp" href="${data.buttonUrl}" class="mod-button02 mt30">
							<span>${data.buttonText}</span>
							<svg class="_right _arrow" aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#arrow_right02"></use></svg>
						</a>
					`;
			
					// Splideインスタンスの再初期化
					if (splideInstance) {
						splideInstance.destroy();
					}
					splideInstance = new Splide('.top-LineupSlide', {
						type: 'loop',
						perPage: 2,
						autoplay: false,
						interval: 5000,
						speed: 500,
						arrows: true,
						pagination: true,
						paginationKeyboard: true,
						gap: 20,
						breakpoints: {
							1025: {
								perPage: 1,
								gap: 0,
							}
						},
					}).mount();

					adjustHeights();
				});
			});
			adjustHeights();
		});
	};

	const topCaseStudySwiper = () => {
		const splide = new Splide('.top-caseStudySlide.splide', {
			type: 'loop',
			perPage: 1,
			autoplay: false,
			interval: 5000,
			speed: 500,
			arrows: true,
			pagination: true,
			paginationKeyboard: true,
			padding: "20%",
			gap: 100,
			breakpoints: {
				1025: {
					padding: "0",
					gap: 0,
				}
			},
		}).mount();
	};

	const topEventSwiper = () => {
		const splide = new Splide('.top-eventSlide.splide', {
			type: "loop",
			perPage: 1,
			perMove: 1,
			pagination: true,
			paginationKeyboard: true,
			gap: "102px",
			breakpoints: {
				1025: {
					gap: 0,
				}
			},
		}).mount();
	};

	const topNewsList = () => {
		const tabs = document.querySelectorAll(".tab");
		const contents = document.querySelectorAll(".tab-content");

		tabs.forEach(tab => {
			tab.addEventListener("click", () => {
				// タブの選択状態をリセット
				tabs.forEach(t => t.classList.remove("active"));
				contents.forEach(content => content.classList.remove("active"));

				// 選択したタブと対応するコンテンツを表示
				tab.classList.add("active");
				const target = document.getElementById(tab.dataset.tab);
				if (target)target.classList.add("active");
			});
		});

		// 初期状態の表示設定
		document.querySelector(".tab").click();
	};

	const caseTagInsert = () => {
		const getJSONfiles = () => '/ajax/news/list.json';
	
		const insertTags = (data) => {
			const items = document.querySelectorAll('.rt_key');
	
			items.forEach(item => {
				const rtKeyValue = item.textContent.trim(); // rt_key の値を取得
	
				const matchedData = data.rt_bn_news_list.find(news => {
					return news._key === rtKeyValue; // JSON の _key と一致するかチェック
				});
	
				if (matchedData) {
					const tagElement = item
						.closest(".__item")
						.querySelector(".js-caseTag");
					if (tagElement) {
						// cf_n_related_solutions 内の cf_nt_name_d を全て取得し、#で連結
						const relatedSolutions = matchedData.cf_n_related_solutions.map(
							(solution) => `${solution.cf_nt_name_d}`
						).join(" ");
						
						// タグ要素に設定
						tagElement.textContent = relatedSolutions;
					}
				}
			});
		};
	
		fetch(getJSONfiles())
			.then(response => {
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				return response.json();
			})
			.then(data => {
				insertTags(data);
			})
			.catch(error => {
				console.error('Error fetching JSON data:', error);
			});
	};
	

	topLineupSwiper();
	topLineupList();
	topCaseStudySwiper();
	topEventSwiper();
	topNewsList();
	caseTagInsert();


})(window.FUNCTIONS);